import React, {useEffect, useState} from "react";
import {Card, Container, Row, Col, Button} from 'react-bootstrap';
import EditDclModal from "./edit-dcl-modal";
import "./newDcl.css";
import { FaCar } from 'react-icons/fa';
import { MdAssignmentAdd } from "react-icons/md";
import {useDispatch, useSelector} from "react-redux";
import Dropdown from "../../../primer/Dropdown";
import {setDclRequestData, setSelectedDcl, setShowSelectedDclModal} from "../../../../_reducers/DataPanel/Dcl/dclSlice";
import {
    checkPermission,
    getAvailableClientServiceTypes,
    getAvailableServiceTypes,
    isEmpty
} from "../../../../_helpers/commonFunctions";
import NewDclModal from "./new-dcl-modal";
import FAB from "../../../primer/FAB";
import {fetchActiveDcl} from "../../../../_apis/api";
import {dclStatusOptions} from "./dclStatusOptions";
import Loader from "../../../primer/POPUP-COMPONENTS/Loader/PrimerLoader";
import moment from "moment";
import Input from "../../../common/Input";
import {IoIosWarning} from "react-icons/io";
import {FiRefreshCcw} from "react-icons/fi";
const statusClass = (status) => {
    switch (status?.toLowerCase()) {
        case 'open': return 'status-open';
        case 'completed': return 'status-completed';
        case 'cancelled': return 'status-cancel';
        default: return '';
    }
};
const NewDcl = () => {
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const companyInstallations = useSelector((state) => state.COMPANY_DATA.companyInstallations);
    const requestData = useSelector((state) => state.DCL.dclRequestData);
    const mainLoader = useSelector((state) => state.DCL.mainActiveDclLoader);
    const permissionsData = JSON.parse(localStorage.getItem("permissions"));
    const clientServiceTypes = getAvailableClientServiceTypes(permissionsData);
    const dclActiveList = useSelector((state) => state.DCL.activeDcl);
    const [showNewDcl, setShowNewDcl] = useState(false);
    const [installationOptions, setInstallationOptions] = useState([]);
    const dclStatusDropdownOptions = [{ label: "Εμφάνιση όλων", value: "" }, ...dclStatusOptions];
    const dclInstallationDefaultOptions = useSelector((state) => state.SALES_SETTINGS?.salesGeneralSettings?.dclInstallationDefaultOptions);
    const currentYear = String(company.year);
    useEffect(() => {
        if (companyInstallations.length > 0) {
            let options = [];
            companyInstallations.forEach((inst) => {
                options.push({ value: inst.installationMasterId, label: inst.type + " " + inst.address + " " + inst.city });
            })
            setInstallationOptions(options);
        }
        let defaultRequestData = {...requestData};
        if(dclInstallationDefaultOptions?.length > 0) {
            defaultRequestData.installation = dclInstallationDefaultOptions.find((op) => String(op.selected) === "true")?.installation || "0";
        } else {
            defaultRequestData.installation = "0";
        }
        if(!requestData?.clientServiceType && clientServiceTypes?.length === 1) {
            defaultRequestData.clientServiceType = clientServiceTypes[0]?.value;
        }
        if(!isEmpty(defaultRequestData.installation) && dclInstallationDefaultOptions?.find((inst) => inst.installation === defaultRequestData.installation)?.clientServiceType) {
            defaultRequestData.clientServiceType = dclInstallationDefaultOptions.find((inst) => inst.installation === defaultRequestData.installation)?.clientServiceType;
        }
        dispatch(setDclRequestData(defaultRequestData));
    }, []);

    useEffect(() => {
        // default option
        let defaultRequestData = {...requestData};
        if(!isEmpty(defaultRequestData.installation)) {
            if(dclInstallationDefaultOptions?.find((inst) => inst.installation === defaultRequestData.installation)?.clientServiceType) {
                dispatch(setDclRequestData({...defaultRequestData, clientServiceType: dclInstallationDefaultOptions.find((inst) => inst.installation === defaultRequestData.installation)?.clientServiceType, forceRefresh: true}))
            } else {
                dispatch(setDclRequestData({...defaultRequestData, forceRefresh: true}));
            }
        }
    }, [requestData.installation]);

    useEffect(() => {
        if(requestData?.forceRefresh) {
            dispatch(setDclRequestData({...requestData, forceRefresh: false}));
        }
        if(!isEmpty(requestData?.installation) && !isEmpty(requestData?.clientServiceType) && requestData?.forceRefresh) {
            dispatch(fetchActiveDcl({...requestData, company: company.id, year: currentYear}, TABS_DATA));
        }
    }, [requestData.forceRefresh]);

    const handleCardClick = (car) => {
        dispatch(setSelectedDcl(car));
        dispatch(setShowSelectedDclModal(true));
    };

    const refreshActiveDcl = () => {
        if(!isEmpty(requestData?.installation) && !isEmpty(requestData?.clientServiceType)) {
            dispatch(fetchActiveDcl({...requestData, company: company.id, year: currentYear}, TABS_DATA, true));
        }
    }

    return (
        <React.Fragment>
            <Row>
                <Col md={3}>
                    <Dropdown
                        name={"installationMasterId"}
                        label={"Εγκατάσταση"}
                        defaultValue={installationOptions.find((el) => el.value === requestData.installation)}
                        key={Math.random()}
                        disabled={mainLoader}
                        className={"w-100 mb-2"}
                        options={installationOptions}
                        onChange={(e) => dispatch(setDclRequestData({...requestData, installation: e.value}))}
                    />
                </Col>
                <Col md={3}>
                    <Dropdown
                        name={"clientServiceType"}
                        label={"Τύπος Ψηφιακού Πελατολογίου"}
                        className={"w-100 mb-2"}
                        defaultValue={clientServiceTypes.find((el) => el.value === requestData.clientServiceType)}
                        key={Math.random()}
                        disabled={mainLoader}
                        options={clientServiceTypes}
                        onChange={(e) => dispatch(setDclRequestData({...requestData, clientServiceType: e.value, forceRefresh: true}))}
                    />
                </Col>
                <Col className="d-flex justify-content-between align-items-center" md={2} style={{alignContent: 'center'}}>
                    <Dropdown
                        name={"dclStatus"}
                        label={"Κατάσταση Εγγραφής"}
                        className={"w-100 mb-2"}
                        defaultValue={dclStatusDropdownOptions.find((el) => el.value === requestData.dclStatus)}
                        key={Math.random()}
                        disabled={mainLoader}
                        options={dclStatusDropdownOptions}
                        onChange={(e) => dispatch(setDclRequestData({...requestData, dclStatus: e.value, forceRefresh: true}))}
                    />
                </Col>
                <Col md={4} className="d-flex justify-content-between align-items-center">
                    <Input
                        label={"Αναζήτηση Εγγραφών"}
                        style={{marginBottom: "10px"}}
                        name={"searchKeyword"}
                        placeholder={"Αναζητήστε με Πελάτη, Πινακίδα, Υπηρεσία"}
                        type={"text"}
                        value={requestData?.searchKeyword}
                        onChange={(e) => dispatch(setDclRequestData({...requestData, searchKeyword: e.target.value, forceRefresh: true}))}
                    />
                    <Button style={{padding: "5px", margin: "10px", marginTop: "25px"}} disabled={mainLoader} variant="primary" onClick={() => refreshActiveDcl()}>
                        {!mainLoader && (<FiRefreshCcw size={20} />)}
                        {mainLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                    </Button>
                </Col>
            </Row>
            <Container className="container-playground">
                <h2 style={{color: "#585858"}} className="mb-4 text-center fw-bold">
                    <FaCar style={{ marginRight: '10px', color: '#585858' }} /> Ψηφιακό Πελατολόγιο</h2>
                {mainLoader && (
                    <div className="overlay_loader">
                    <Loader />
                    </div>
                )}
                {(isEmpty(requestData?.installation) || isEmpty(requestData?.clientServiceType)) ? (
                        <div className="overlay_w">Παρακαλώ επιλέξτε Εγκατάσταση και Τύπο Ψηφιακού Πελατολογίου...</div>
                ) : (
                    <div className="cards-scrollable">
                        <Row xs={1} sm={2} md={3} lg={4} xl={5}>
                            {dclActiveList?.length > 0 && dclActiveList.map((car) => (
                                <Col key={car._id} style={{border: "10px black"}}>
                                    <Card onClick={() => handleCardClick(car)} className="shadow-md card-hover">
                                        <Card.Body className="d-flex flex-column justify-content-center text-center" style={{padding: "0.5rem 0.75rem"}}>
                                            {(
                                                !isEmpty(car?.offlineNewDcl) ||
                                                !isEmpty(car?.offlineEditDcl) ||
                                                !isEmpty(car?.offlineCancelDcl) ||
                                                !isEmpty(car?.offlineCorrelateDcl)
                                            ) ? (
                                                <Card.Title style={{marginBottom: "0.5rem"}}>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <IoIosWarning size={25} color={"red"} />
                                                        <span>{car.vehicleRegistrationNumber}</span>
                                                        <IoIosWarning size={25} color={"red"} />
                                                    </div>
                                                    <hr style={{width: "100%", marginLeft: "auto", marginRight: "auto", marginTop: "0.5rem", marginBottom: "0"}}/>
                                                </Card.Title>
                                            ) : (
                                                    <Card.Title style={{marginBottom: "0.5rem"}}>{car.vehicleRegistrationNumber} <hr style={{width: "100%", marginLeft: "auto", marginRight: "auto", marginTop: "0.5rem", marginBottom: "0"}}/></Card.Title>
                                                )}
                                            <div style={{fontSize: "12px"}} className="d-flex justify-content-between">
                                                <span style={{textAlign: 'start'}} className={'fw-bold'}>Ημερομηνία {car?.clientServiceType === "1" ? "Αναχώρησης": "Εισόδου"}:</span>
                                                <span style={{textAlign: 'end'}}>{`${moment(car.creationDateTime).format("DD/MM/YYYY HH:mm")}`}</span>
                                            </div>
                                            <div style={{fontSize: "12px"}} className="d-flex justify-content-between">
                                                <span style={{textAlign: 'start'}} className={'fw-bold'}>Όχημα:</span>
                                                <span style={{textAlign: 'end'}}>{`${car.vehicleCategory} ${car.vehicleFactory}`}</span>
                                            </div>
                                            <div style={{fontSize: "12px"}} className="d-flex justify-content-between">
                                                <span style={{textAlign: 'start'}} className={'fw-bold'}>Πελάτης:</span>
                                                <span style={{textAlign: 'end'}}>{`${car.clientName} (${car.clientVatNumber})`}</span>
                                            </div>
                                            <div style={{fontSize: "12px"}} className="d-flex justify-content-between">
                                                <span style={{textAlign: 'start'}} className={'fw-bold'}>Υπηρεσία:</span>
                                                <span style={{textAlign: 'end'}}>{`${getAvailableServiceTypes().find((op) => op.value === car.serviceCategory)?.label}`}</span>
                                            </div>
                                        </Card.Body>
                                        <Card.Footer style={{padding: "0.5rem 0.75rem"}}>
                                            {!isEmpty(car?.dclId) && (
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <span style={{fontSize: "11px"}} className={"text-muted"}><i>Κωδικός Εγγραφής:</i></span>
                                                    <span style={{fontSize: "11px"}} className={"text-muted"}><i>{car?.dclId}</i></span>
                                                </div>
                                            )}
                                            {!isEmpty(car?.cancelDateTime) && (
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <span style={{fontSize: "11px"}} className={"text-muted"}><i>Ημερομηνία Ακύρωσης:</i></span>
                                                    <span style={{fontSize: "11px"}} className={"text-muted"}><i>{moment(car.cancelDateTime).format("DD/MM/YYYY HH:mm")}</i></span>
                                                </div>
                                            )}
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span>Κατάσταση:</span>
                                                <span className={`fw-bold ${statusClass(car.status)}`}>{dclStatusOptions.find((op) => op.value === car.status)?.label}</span>
                                            </div>
                                        </Card.Footer>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </div>
                )}
            </Container>
            <NewDclModal show={showNewDcl} setShow={setShowNewDcl} clientServiceType={requestData?.clientServiceType} companyInstallations={installationOptions} />
            <EditDclModal companyInstallations={installationOptions} />
            <FAB disabled={mainLoader || isEmpty(requestData?.installation) || isEmpty(requestData?.clientServiceType) || !checkPermission('sales-dcl/new-write', permissionsData)} content={<><MdAssignmentAdd size={30} style={{paddingRight: "5px"}} /> {" Δημιουργία Εγγραφής Πελατολογίου "} <MdAssignmentAdd size={30} style={{paddingLeft: "5px"}} /></>} onClick={() => setShowNewDcl(true)}/>
        </React.Fragment>
    );
}

export default NewDcl;
